import React, { useEffect } from "react";
import "../src/Assets/font/PlayfairDisplay-Black.ttf";
import "../src/Assets/font/PlayfairDisplay-BlackItalic.ttf";
import "../src/Assets/font/PlayfairDisplay-Bold.ttf";
import "../src/Assets/font/PlayfairDisplay-BoldItalic.ttf";
import "../src/Assets/font/PlayfairDisplay-Italic_0.ttf";
import "../src/Assets/font/PlayfairDisplay-Regular.ttf";
import "../src/Assets/font/sofiapro-light.otf";
import "./App.css";
import "react-slideshow-image/dist/styles.css";
import Landing from "./Pages/Landing/Landing";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import SignUp from "./Pages/Authentication&Profile/SignUp";
import Login from "./Pages/Authentication&Profile/Login";
import Gallery from "./Pages/Gallery/Gallery";
import Exhibition from "./Pages/Exhibition&Event/Exhiibition";
import Event from "./Pages/Exhibition&Event/Event";
import Framing from "./Pages/Framing/Framing";
import OnlineFraming from "./Pages/Framing/OnlineFramnig";
import Measure from "./Pages/Framing/Measure";
import OnlinePrinting from "./Pages/Printing/OnlinePrinting";
import Upload from "./Pages/Printing/Upload";
import Printing from "./Pages/Printing/Printing";
import Shop from "./Pages/Shop/Shop";
import TermsConditions from "./Pages/Terms&Conditions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import ContactUs from "./Pages/ContactUs";
import Artists from "./Pages/Artist/Artists";
import Artist from "./Pages/Artist/Artist";
import InStoreFraming from "./Pages/Framing/InStoreFraming";
import { initializeParse } from "@parse/react";
import Artwork from "./Pages/Artwork/Artwork";
import Blogs from "./Pages/Blog/Blogs";
import Blog from "./Pages/Blog/Blog";
import Cart from "./Pages/Cart&Payment/Cart";
import Memorabilia from "./Pages/Memorabilia/Memorabilia";
import ForgetPass from "./Pages/Authentication&Profile/ForgetPass";
import PaymentResult from "./Pages/Cart&Payment/PaymentResult";
import Profile from "./Pages/Authentication&Profile/Profile";
import Order from "./Pages/Authentication&Profile/Order";
import EditProfile from "./Pages/Authentication&Profile/EditProfile";
import Temp from "./Pages/temp";
import AboutUs from "./Pages/AboutUs";
import { CartProvider } from "./Context/CartContext";

if (
  process.env.PARSE_APP_ID &&
  process.env.PARSE_JS_KEY &&
  process.env.YOUR_SERVER_URL
)
  initializeParse(
    process.env.PARSE_APP_ID,
    process.env.PARSE_JS_KEY,
    process.env.YOUR_SERVER_URL,
  );
function App() {
  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    onTop();
  }, [routePath]);
  // document.addEventListener("DOMContentLoaded", () => {
  //   const lazyImages = document.querySelectorAll("img.lazy");
  //   const imageObserver = new IntersectionObserver((entries, observer) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         const img: any = entry.target;
  //         console.log(img.src);
  //         img.onload = function () {
  //           img.removeAttribute("data-src");
  //           img.classList.remove("d-none");
  //         };
  //         observer.unobserve(img);
  //       }
  //     });
  //   });

  //   lazyImages.forEach((img) => {
  //     imageObserver.observe(img);
  //   });
  // });
  return (
    <Routes>
      <Route path="/*" element={<Navigate to="/" />}></Route>
      <Route path="/" element={<Landing />}></Route>
      <Route path="/home" element={<Navigate to="/" />}></Route>
      <Route path="/signup" element={<SignUp />}></Route>
      <Route path="/login" element={<Login />}></Route>
      <Route path="/forget-password" element={<ForgetPass />}></Route>
      <Route path="/gallery" element={<Gallery />}></Route>
      <Route
        path="/gallery/exhibition/:exhibitionId"
        element={<Exhibition />}
      ></Route>
      <Route path="/gallery/event/:eventId" element={<Event />}></Route>
      <Route path="/framing" element={<Framing />}></Route>
      <Route path="/measure" element={<Measure />}></Route>
      <Route path="/online-framing/:mode" element={<OnlineFraming />}></Route>
      <Route path="/online-printing/:mode" element={<OnlinePrinting />}></Route>
      <Route path="/upload" element={<Upload />}></Route>
      <Route path="/printing" element={<Printing />}></Route>
      <Route path="/shop" element={<Shop />}></Route>
      <Route path="/artwork/:artworkId" element={<Artwork />}></Route>
      <Route path="/terms&conditions" element={<TermsConditions />}></Route>
      <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
      <Route path="/contact-us" element={<ContactUs />}></Route>
      <Route path="/about-us" element={<AboutUs />}></Route>
      <Route path="/artist" element={<Artists />}></Route>
      <Route path="/artist/:artistName" element={<Artist />}></Route>
      <Route path="/instore-framing" element={<InStoreFraming />}></Route>
      <Route path="/blog/:blogId" element={<Blog />}></Route>
      <Route path="/blogs" element={<Blogs />}></Route>
      <Route path="/cart" element={<Cart />}></Route>
      <Route path="/success" element={<PaymentResult />} />
      <Route path="/canceled" element={<Navigate to="/cart" />} />
      <Route path="/memorabilia" element={<Memorabilia />}></Route>{" "}
      <Route path="/profile" element={<Profile />}></Route>
      <Route path="/order/:orderId" element={<Order />}></Route>
      <Route path="/edit-profile" element={<EditProfile />}></Route>
    </Routes>
  );
}

export default App;
